import React from 'react';
import CommonPopup from '../../../../common/CommonPopup';
import InputBox from '../../../../common/InputBox';

interface Props {
  submitDisabled: boolean;
  modalInfo: {
    type: string;
    show: boolean;
    uuid: string;
    storeName: string;
    subDomain: string;
    userName: string;
    token: string;
  };
  setModalInfo: any;
  onClose: () => void;
  handleDataSourceConnect: (storeName: string) => void;
  handleDeskCRMConnect: () => void;
}

const DataSourceInfoPopup = (props: Props) => {
  const {
    submitDisabled,
    modalInfo,
    onClose,
    setModalInfo,
    handleDataSourceConnect,
    handleDeskCRMConnect
  } = props;

  const baseStoreName = modalInfo.storeName.split('.myshopify.com')[0] || '';

  const handleSubmit = () => {
    const finalStoreName = `${baseStoreName}.myshopify.com`;
    handleDataSourceConnect(finalStoreName);
  };

  return (
    <CommonPopup onClose={onClose}>
      {modalInfo.type === 'Shopify' ? (
        <div className="flex flex-col gap-1.5">
          <label
            htmlFor={'BaseStoreName'}
            className="block font-normal text-[#F3F3E0] text-lg leading-[29.64px]"
          >
            Store Name
          </label>
          <div className="flex flex-wrap gap-4 items-center sm:flex-nowrap sm:gap-4 sm:flex-row">
            <div className="relative flex-1 min-w-[200px]">
              <input
                type="text"
                name="BaseStoreName"
                value={baseStoreName}
                placeholder="example"
                onChange={(e) =>
                  setModalInfo({ ...modalInfo, storeName: `${e.target.value}.myshopify.com` })
                }
                className="block w-full h-[48px]  rounded-lg border-0 pt-4 pb-5 pr-[140px] md:pr-[193px] sm:pr-[195px] pl-5  shadow-sm bg-[#343434] placeholder:text-[#F3F3E099] placeholder:font-normal  sm:text-base sm:leading-[28.13px] "
              />
              <span
                className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white font-medium sm:text-lg"
                style={{ pointerEvents: 'none' }}
              >
                .myshopify.com
              </span>
            </div>
            <button
              className={`${submitDisabled ? 'bg-[#cccccc] cursor-not-allowed' : 'bg-[#006BEA] cursor-pointer'} text-white font-medium text-base px-4 py-2 rounded w-full sm:w-auto`}
              onClick={handleSubmit}
              disabled={submitDisabled}
            >
              Submit
            </button>
          </div>
        </div>
      ) : (
        <div className={'flex flex-col'}>
          <div className="flex flex-col">
            <label htmlFor={'BaseStoreName'} className="font-normal text-[#F3F3E0] text-lg">
              Sub Domain
            </label>
            {modalInfo.type === 'Zendesk' ? (
              <label className="font-normal text-[#adadad] text-sm pb-2">
                To find your Zendesk subdomain, check your account URL (e.g.,
                yoursubdomain.zendesk.com) and <br /> enter the part before .zendesk.com
              </label>
            ) : (
              <label className="font-normal text-[#adadad] text-sm pb-2">
                To find your Freshdesk subdomain, check your account URL (e.g.,
                yoursubdomain.freshdesk.com) and <br /> enter the part before .freshdesk.com
              </label>
            )}
            <InputBox
              name="Domain"
              type="text"
              value={modalInfo.subDomain}
              handleChange={(e) => setModalInfo({ ...modalInfo, subDomain: e.target.value })}
              placeholder="Enter sub domain"
            />
          </div>
          <div className="flex flex-col">
            <label
              htmlFor={'BaseStoreName'}
              className="block font-normal text-[#F3F3E0] text-lg leading-[29.64px]"
            >
              Token
            </label>
            {modalInfo.type === 'Zendesk' ? (
              <label className="font-normal text-[#adadad] text-sm pb-2">
                To get a Zendesk API token, go to Admin Center &#x3E; Apps and Integrations &#x3E;
                APIs &#x3E; Zendesk API, <br /> enable API token access, and click Add API Token
              </label>
            ) : (
              <label className="font-normal text-[#adadad] text-sm pb-2">
                To get a Freshdesk API token, log in to your Freshdesk account, click on your
                profile icon (top-right corner),
                <br /> and find the API Key under your profile settings.
              </label>
            )}
            <InputBox
              name="token"
              type="text"
              value={modalInfo.token}
              handleChange={(e) => setModalInfo({ ...modalInfo, token: e.target.value })}
              placeholder="Enter token"
            />
          </div>
          {modalInfo.type === 'Zendesk' && (
            <div className="flex flex-col">
              <label
                htmlFor={'BaseStoreName'}
                className="block font-normal text-[#F3F3E0] text-lg leading-[29.64px]"
              >
                User Name
              </label>
              <label className="font-normal text-[#adadad] text-sm pb-2">
                Please enter the email that you used to create your Zendesk account
              </label>
              <InputBox
                name="username"
                type="text"
                value={modalInfo.userName}
                handleChange={(e) => setModalInfo({ ...modalInfo, userName: e.target.value })}
                placeholder="Enter username"
              />
            </div>
          )}
          <button
            className="bg-[#006BEA] text-white font-medium text-sm px-4 py-1.5 rounded mt-3 flex self-center"
            onClick={handleDeskCRMConnect}
          >
            Submit
          </button>
        </div>
      )}
    </CommonPopup>
  );
};

export default DataSourceInfoPopup;
